import { useIsAuthenticated } from '@azure/msal-react';
import './ccf-protected-route.module.scss';
import { Redirect } from 'react-router-dom';
import { Route , RouteProps } from 'react-router-dom';

/* eslint-disable-next-line */
export interface CcfProtectedRouteProps extends RouteProps {}

/**
 * Component to provide protected routes for application
 * @param param0 - CcfProtectedRouteProps
 * @example - <CcfProtectedRoute />
 * @returns 
 */
export function CcfProtectedRoute({children,...others}: CcfProtectedRouteProps) {
  const isAuthenticated = useIsAuthenticated();
  return (
    <Route {...others}>
      {(isAuthenticated && children) || <Redirect to="/login" />}
    </Route>
  );
}

export default CcfProtectedRoute;